import { createAction, props } from '@ngrx/store';
import { FilterParamsMap, RouterActionTypes } from './router.models';
import { NavigationExtras } from '@angular/router';

/**
 * action which triggers router.navigate()
 *
 * @param url array of URL fragments for target url
 * @param queryParams specific list of queryParams, use like { [ParamsKey.FILTER]: 'filterString' }
 * @param extras NavigationExtras, default is { queryParamsHandling: 'merge' }
 */
export const navigate = createAction(
    RouterActionTypes.NAVIGATE,
    props<{ url: (string | number)[]; queryParams?: FilterParamsMap; extras?: NavigationExtras }>()
);
export const navigateForward = createAction(RouterActionTypes.FORWARD);
export const navigateBackward = createAction(RouterActionTypes.BACKWARD);
